var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _polygon2, _polygon3, _path14, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _path15, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebLogoFullWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 7288.48 988.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 494.93,
    y1: 849.46,
    x2: 983.91,
    y2: 849.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e2575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f0f2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 529,
    y1: 446.3,
    x2: 632.39,
    y2: 625.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7c3aba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e1d5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 601.47,
    y1: 338.73,
    x2: 730.15,
    y2: 587.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 995.79,
    y1: 976.5,
    x2: 790.05,
    y2: 770.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 749.39,
    y1: 582.52,
    x2: 786.3,
    y2: 645.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc3f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b02d41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 550.96,
    y1: 466.46,
    x2: 514.94,
    y2: 446.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 790.08,
    y1: 736.55,
    x2: 757.09,
    y2: 679.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 3442.62,
    y1: 849.46,
    x2: 3931.6,
    y2: 849.46,
    gradientTransform: "translate(3937.51) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c3aba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e1d5e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 3476.6,
    y1: 446.17,
    x2: 3580.06,
    y2: 625.37,
    gradientTransform: "translate(3937.51) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a45beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e33a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 3549.31,
    y1: 339.03,
    x2: 3678,
    y2: 587.68,
    gradientTransform: "translate(3937.51) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 3943.48,
    y1: 976.5,
    x2: 3737.73,
    y2: 770.75,
    gradientTransform: "translate(3937.51) rotate(-180) scale(1 -1)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.64,
    y1: 451.54,
    x2: 455.33,
    y2: 760.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8cc9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f0932a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9314a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 3498.65,
    y1: 466.46,
    x2: 3462.63,
    y2: 446.12,
    gradientTransform: "translate(3937.51) rotate(-180) scale(1 -1)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 3737.77,
    y1: 736.55,
    x2: 3704.78,
    y2: 679.41,
    gradientTransform: "translate(3937.51) rotate(-180) scale(1 -1)",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 989.83,
    y1: 520.22,
    x2: 648.61,
    y2: 520.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc3f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b02d41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0,
    y1: 520.21,
    x2: 341.11,
    y2: 520.21,
    xlinkHref: "#n"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1574.53,659.76h-186.11l-29.83,88.08h-127.15l180.43-498.66h140.65l180.43,498.66h-128.57l-29.83-88.08ZM1543.27,565.99l-61.8-182.56-61.09,182.56h122.89Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1793.31,632.76c46.41-38.36,82.99-69.85,109.75-94.48,26.75-24.62,49.37-50.43,67.84-77.43,18.47-26.99,27.7-53.28,27.7-78.85,0-19.41-4.5-34.56-13.49-45.46-9-10.89-22.5-16.34-40.49-16.34s-32.09,6.75-42.27,20.24c-10.19,13.5-15.27,32.56-15.27,57.18h-117.21c.94-40.25,9.59-73.88,25.93-100.87,16.34-26.99,37.88-46.88,64.64-59.67,26.75-12.79,56.47-19.18,89.15-19.18,56.35,0,98.85,14.45,127.51,43.33,28.65,28.89,42.98,66.54,42.98,112.95,0,50.68-17.29,97.67-51.85,141-34.57,43.33-78.62,85.6-132.12,126.8h191.79v98.74h-356.59v-90.22c16.09-12.79,23.44-18.7,22.02-17.76Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2450.73,720.13c-39.07-21.78-70.09-52.21-93.06-91.28-22.98-39.07-34.45-82.99-34.45-131.77s11.47-92.58,34.45-131.41c22.97-38.82,53.99-69.14,93.06-90.92,39.07-21.78,82.05-32.68,128.93-32.68s89.86,10.9,128.93,32.68c39.07,21.79,69.85,52.1,92.35,90.92,22.48,38.83,33.74,82.64,33.74,131.41s-11.37,92.7-34.09,131.77c-22.73,39.07-53.52,69.5-92.35,91.28-38.83,21.79-81.69,32.68-128.57,32.68s-89.86-10.89-128.93-32.68ZM2675.2,602.22c23.91-26.51,35.87-61.56,35.87-105.13s-11.96-79.2-35.87-105.49c-23.92-26.28-55.76-39.42-95.54-39.42s-72.35,13.03-96.25,39.07c-23.92,26.05-35.87,61.33-35.87,105.84s11.95,79.2,35.87,105.49c23.91,26.28,56,39.43,96.25,39.43s71.62-13.25,95.54-39.78Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2901.09,441.68c15.38-30.78,36.34-54.45,62.86-71.03,26.51-16.57,56.12-24.86,88.79-24.86,26.04,0,49.84,5.45,71.39,16.34,21.54,10.9,38.47,25.57,50.79,44.04v-183.98h121.47v525.66h-121.47v-56.83c-11.37,18.95-27.6,34.1-48.66,45.46-21.08,11.37-45.58,17.05-73.52,17.05-32.67,0-62.28-8.4-88.79-25.22-26.53-16.8-47.48-40.72-62.86-71.74-15.4-31.01-23.09-66.88-23.09-107.62s7.69-76.47,23.09-107.26ZM3149.71,477.91c-16.81-17.51-37.29-26.28-61.44-26.28s-44.64,8.65-61.45,25.93c-16.81,17.29-25.22,41.09-25.22,71.39s8.4,54.34,25.22,72.1c16.81,17.76,37.29,26.64,61.45,26.64s44.63-8.76,61.44-26.28c16.81-17.51,25.22-41.43,25.22-71.74s-8.41-54.22-25.22-71.74Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3789.37,351.46l-248.62,584.62h-130.71l90.92-201.74-161.25-382.88h135.68l91.64,247.91,90.92-247.91h131.41Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3902.3,735.76c-26.99-11.83-48.3-28.06-63.93-48.66-15.63-20.6-24.4-43.69-26.28-69.26h120.05c1.42,13.74,7.81,24.86,19.18,33.39,11.37,8.52,25.33,12.79,41.91,12.79,15.15,0,26.87-2.95,35.16-8.88,8.28-5.92,12.43-13.61,12.43-23.09,0-11.37-5.93-19.77-17.76-25.22-11.85-5.44-31.02-11.48-57.54-18.12-28.41-6.63-52.1-13.61-71.03-20.95-18.95-7.34-35.28-18.93-49.01-34.81-13.74-15.86-20.6-37.29-20.6-64.29,0-22.73,6.27-43.44,18.82-62.16,12.54-18.7,31.01-33.5,55.41-44.4,24.39-10.89,53.39-16.34,87.02-16.34,49.72,0,88.9,12.32,117.56,36.94,28.65,24.63,45.1,57.31,49.37,98.03h-112.23c-1.9-13.73-7.94-24.62-18.11-32.68-10.19-8.05-23.57-12.08-40.14-12.08-14.21,0-25.1,2.73-32.68,8.17-7.58,5.45-11.37,12.91-11.37,22.38,0,11.37,6.04,19.89,18.12,25.57,12.08,5.68,30.9,11.36,56.47,17.05,29.36,7.58,53.28,15.04,71.75,22.38,18.47,7.35,34.69,19.18,48.66,35.52,13.96,16.34,21.19,38.25,21.67,65.71,0,23.21-6.51,43.93-19.53,62.16-13.03,18.24-31.73,32.56-56.12,42.98-24.4,10.41-52.69,15.63-84.89,15.63-34.57,0-65.35-5.92-92.35-17.76Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4298.68,735.76c-26.99-11.83-48.3-28.06-63.93-48.66-15.63-20.6-24.4-43.69-26.28-69.26h120.05c1.42,13.74,7.81,24.86,19.18,33.39,11.37,8.52,25.33,12.79,41.91,12.79,15.15,0,26.87-2.95,35.16-8.88,8.28-5.92,12.43-13.61,12.43-23.09,0-11.37-5.93-19.77-17.76-25.22-11.85-5.44-31.02-11.48-57.54-18.12-28.41-6.63-52.1-13.61-71.03-20.95-18.95-7.34-35.28-18.93-49.01-34.81-13.74-15.86-20.6-37.29-20.6-64.29,0-22.73,6.27-43.44,18.82-62.16,12.54-18.7,31.01-33.5,55.41-44.4,24.39-10.89,53.39-16.34,87.02-16.34,49.72,0,88.9,12.32,117.56,36.94,28.65,24.63,45.1,57.31,49.37,98.03h-112.23c-1.9-13.73-7.94-24.62-18.11-32.68-10.19-8.05-23.57-12.08-40.14-12.08-14.21,0-25.1,2.73-32.68,8.17-7.58,5.45-11.37,12.91-11.37,22.38,0,11.37,6.04,19.89,18.12,25.57,12.08,5.68,30.9,11.36,56.47,17.05,29.36,7.58,53.28,15.04,71.75,22.38,18.47,7.35,34.69,19.18,48.66,35.52,13.96,16.34,21.19,38.25,21.67,65.71,0,23.21-6.51,43.93-19.53,62.16-13.03,18.24-31.73,32.56-56.12,42.98-24.4,10.41-52.69,15.63-84.89,15.63-34.57,0-65.35-5.92-92.35-17.76Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4997.66,578.77h-274.91c1.89,24.63,9.82,43.45,23.8,56.47,13.96,13.03,31.13,19.54,51.5,19.54,30.3,0,51.38-12.79,63.22-38.36h129.28c-6.64,26.05-18.59,49.49-35.87,70.32-17.29,20.84-38.96,37.18-65,49.01-26.05,11.84-55.17,17.76-87.37,17.76-38.84,0-73.41-8.28-103.71-24.86-30.31-16.57-53.99-40.24-71.04-71.03-17.05-30.78-25.57-66.77-25.57-107.97s8.4-77.18,25.22-107.97c16.81-30.78,40.37-54.45,70.68-71.03,30.3-16.57,65.11-24.86,104.42-24.86s72.45,8.06,102.29,24.15c29.83,16.1,53.15,39.07,69.97,68.9,16.81,29.83,25.22,64.64,25.22,104.42,0,11.37-.71,23.21-2.13,35.52ZM4875.48,511.29c0-20.83-7.1-37.4-21.31-49.72-14.21-12.31-31.97-18.47-53.28-18.47s-37.54,5.93-51.5,17.76c-13.98,11.84-22.62,28.66-25.93,50.43h152.02Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5468.62,351.46l-248.62,584.62h-130.7l90.92-201.74-161.25-382.88h135.68l91.63,247.91,90.92-247.91h131.42Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5784.71,654.07h159.12v93.77h-280.58V249.17h121.47v404.9Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6001,441.68c15.38-30.78,36.34-54.45,62.86-71.03,26.51-16.57,56.12-24.86,88.79-24.86,27.94,0,52.45,5.68,73.52,17.05,21.06,11.37,37.29,26.28,48.66,44.75v-56.12h121.47v396.37h-121.47v-56.12c-11.85,18.47-28.3,33.39-49.37,44.75-21.08,11.37-45.58,17.05-73.52,17.05-32.21,0-61.57-8.4-88.08-25.22-26.53-16.8-47.48-40.72-62.86-71.74-15.4-31.01-23.09-66.88-23.09-107.62s7.69-76.47,23.09-107.26ZM6249.62,477.91c-16.81-17.51-37.29-26.28-61.44-26.28s-44.64,8.65-61.45,25.93c-16.81,17.29-25.22,41.09-25.22,71.39s8.4,54.34,25.22,72.1c16.81,17.76,37.29,26.64,61.45,26.64s44.63-8.76,61.44-26.28c16.81-17.51,25.22-41.43,25.22-71.74s-8.41-54.22-25.22-71.74Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6654.86,362.83c21.31-11.37,45.7-17.05,73.16-17.05,32.68,0,62.27,8.29,88.79,24.86,26.52,16.58,47.47,40.26,62.87,71.03,15.38,30.79,23.08,66.54,23.08,107.26s-7.7,76.61-23.08,107.62c-15.4,31.02-36.35,54.94-62.87,71.74-26.53,16.82-56.12,25.22-88.79,25.22-27.95,0-52.33-5.57-73.16-16.69-20.85-11.12-37.18-25.93-49.01-44.4v55.41h-121.47V222.18h121.47v185.4c11.37-18.47,27.7-33.39,49.01-44.75ZM6753.96,477.55c-16.81-17.28-37.54-25.93-62.15-25.93s-44.64,8.77-61.45,26.28c-16.81,17.53-25.22,41.44-25.22,71.74s8.4,54.23,25.22,71.74c16.81,17.53,37.29,26.28,61.45,26.28s44.75-8.88,61.8-26.64c17.05-17.76,25.57-41.79,25.57-72.1s-8.41-54.1-25.22-71.39Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7035.6,735.76c-26.99-11.83-48.3-28.06-63.93-48.66-15.63-20.6-24.4-43.69-26.28-69.26h120.05c1.42,13.74,7.81,24.86,19.18,33.39,11.37,8.52,25.33,12.79,41.91,12.79,15.15,0,26.87-2.95,35.16-8.88,8.28-5.92,12.43-13.61,12.43-23.09,0-11.37-5.93-19.77-17.76-25.22-11.85-5.44-31.02-11.48-57.54-18.12-28.41-6.63-52.1-13.61-71.03-20.95-18.95-7.34-35.28-18.93-49.01-34.81-13.74-15.86-20.6-37.29-20.6-64.29,0-22.73,6.27-43.44,18.82-62.16,12.54-18.7,31.01-33.5,55.41-44.4,24.39-10.89,53.39-16.34,87.02-16.34,49.72,0,88.9,12.32,117.56,36.94,28.65,24.63,45.1,57.31,49.37,98.03h-112.23c-1.9-13.73-7.94-24.62-18.11-32.68-10.19-8.05-23.57-12.08-40.14-12.08-14.21,0-25.1,2.73-32.68,8.17-7.58,5.45-11.37,12.91-11.37,22.38,0,11.37,6.04,19.89,18.12,25.57,12.08,5.68,30.9,11.36,56.47,17.05,29.36,7.58,53.28,15.04,71.75,22.38,18.47,7.35,34.69,19.18,48.66,35.52,13.96,16.34,21.19,38.25,21.67,65.71,0,23.21-6.51,43.93-19.53,62.16-13.03,18.24-31.73,32.56-56.12,42.98-24.4,10.41-52.69,15.63-84.89,15.63-34.57,0-65.35-5.92-92.35-17.76Z",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "812.85 637.69 914.94 579.09 869.36 668.94 812.85 637.69",
    fill: "#972638"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.93 710.58 494.93 818.24 794.67 988.34 983.91 988.34 494.93 710.58",
    fill: "url(#c)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "495.08 502.07 495.08 249.67 673.04 609.73 575.83 665.28 495.08 502.07",
    fill: "url(#d)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M494.89,250.07l177.96,359.39,96.88-54.2L494.89,0s-1.87,250.07,0,250.07Z",
    fill: "url(#e)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "847.91 712.89 983.94 988.34 771 867.44 847.91 712.89",
    fill: "url(#f)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.92 710.58 989.71 430.42 914.95 579.07 590.84 765.22 494.92 710.58",
    fill: "url(#g)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "590.86 765.24 700.92 702.01 819.3 771.8 771.35 868.06 590.86 765.24",
    fill: "#330d13"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "700.92 702.02 812.89 637.72 869.35 668.94 819.3 771.8 700.92 702.02",
    fill: "#651924"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.93 501.84 494.93 249.44 557.52 376.36 494.93 501.84",
    fill: "#a45beb"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "557.91 378.28 494.87 501.74 513.5 537.42 598.17 457.65 557.91 378.28",
    fill: "url(#h)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "914.95 579.07 590.84 765.22 672.08 809.6 844.7 718.57 914.95 579.07",
    fill: "url(#i)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "176.98 637.69 74.88 579.09 120.46 668.94 176.98 637.69",
    fill: "#e58e31"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.89 710.58 494.89 818.24 195.16 988.34 5.91 988.34 494.89 710.58",
    fill: "url(#j)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.89 501.84 494.89 249.44 316.82 609.75 414.14 665.05 494.89 501.84",
    fill: "url(#k)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M494.78,250.37l-177.96,359.39-96.88-54.2L494.78.3s1.87,250.07,0,250.07Z",
    fill: "url(#l)"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "141.91 712.89 5.88 988.34 218.83 867.44 141.91 712.89",
    fill: "url(#m)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.9 710.58 .11 430.42 74.87 579.07 398.98 765.22 494.9 710.58",
    fill: "url(#n)"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "398.96 765.24 288.91 702.01 170.52 771.8 218.47 868.06 398.96 765.24",
    fill: "#b02d41"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "288.9 702.02 176.93 637.72 120.47 668.94 170.52 771.8 288.9 702.02",
    fill: "#e23c44"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "494.89 501.84 494.89 249.44 432.3 376.36 494.89 501.84",
    fill: "#a45beb"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "431.91 378.28 494.95 501.74 476.32 537.42 391.65 457.65 431.91 378.28",
    fill: "url(#o)"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "74.87 579.07 398.98 765.22 319 810.81 145.12 718.57 74.87 579.07",
    fill: "url(#p)"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "989.83 430.68 648.61 560.44 673.02 609.76 989.83 430.68",
    fill: "url(#q)"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 430.67 341.11 560.69 316.82 609.75 0 430.67",
    fill: "url(#r)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLogoFullWhite);
export default __webpack_public_path__ + "static/media/web-logo-full-white.964d3997ac8d982d5cea72cbc471015e.svg";
export { ForwardRef as ReactComponent };